import React, { useState } from 'react';

const JackpotSlider = () => {
    const gameIcons = [
        '0fef06a8.png', '01a11d6e.png', '1c4654d0.png', '1c30469b.png', '1d7da251.png',
        '1fcf1f40.png', '2c8b1f69.png', '3d69bbf5.png', '3ed9de05.png', '4ca33db1.png',
        '5b4f52b8.png', '5f8f2a90.png', '6c19396c.png', '6c095156.png', '6e3dd021.png',
        '6f93166f.png', '7abe0748.png', '7d601e56.png', '7ffbc8d6.png', '8a19a680.png',
        '8e4458d2.png', '9bda58e3.png', '9cb991ed.png', '9cf7d0be.png', '9d1e5dca.png',
        '18c5fe87.png', '35affbdc.png', '45f37a89.png', '49ee0974.png', '050aef42.png',
        '56ef5f45.png', '57f0ea81.png', '77e281f3.png', '86d246a0.png', '87b43a8a.png',
        '208be8ea.png', '276d7e0c.png', '281f422d.png', '0372c7b0.png', '394ce800.png',
        '462c0126.png', '503be228.png', '593aff0d.png', '615fa258.png', '632cd87e.png',
        '00633fdb.png', '722a5c8c.png', '722d88a9.png', '891bead7.png', '2014dac2.png',
        '2100b24d.png', '3094d6a6.png', '3932a206.png', '4635f51e.png', '5609a19a.png',
        '6448e32e.png', '9455d986.png', '40786c5b.png', '477777e0.png', '518292a0.png',
        '9930716d.png', '12598263.png', '59425949.png', 'a9252020.png', 'ab03d5d3.png',
        'ab68c5cf.png', 'ad11d2ce.png', 'aeb3c183.png', 'b1ec920f.png', 'b574e526.png',
        'b6814d30.png', 'bbdba57f.png', 'bc94e39c.png', 'bcf94f98.png', 'bec41b26.png',
        'bf0ff35e.png', 'c2cc71cb.png', 'c2d48a30.png', 'c9e53079.png', 'c84e1a9e.png',
        'c118ee2c.png', 'c5350a3e.png', 'ca45c037.png', 'd0d8d5be.png', 'd6b36ce6.png',
        'de065e33.png', 'e2b66c55.png', 'e48dcbf8.png', 'e1030e10.png', 'e280976c.png',
        'eb5381b3.png', 'ed029b44.png', 'ed094e26.png', 'eff10237.png', 'f4f9420c.png',
        'f93bbe7e.png', 'f430e761.png', 'f4729b69.png', 'fd48b848.png', 'fdda4daa.png',
        'fdf04262.png', 'ff36a0bf.png', 'ffeabf60.png'
    ];

    // กำหนด type สำหรับ card data
    interface JackpotCard {
        id: number;
        phoneNumber: string;
        minutesAgo: number;
        amount: string;
        gameIcon: string;
    }

    // สุ่มข้อมูล jackpot
    const generateJackpotData = (): JackpotCard[] => {
        const cards: JackpotCard[] = [];
        for (let i = 0; i < 20; i++) {
            const phoneNumber = `xxxxxx${Math.floor(Math.random() * 10000).toString().padStart(4, '0')}`;
            const minutesAgo = Math.floor(Math.random() * 30) + 1;
            const amount = Math.floor(Math.random() * 25000) + 5000;
            const gameIcon = gameIcons[Math.floor(Math.random() * gameIcons.length)];

            cards.push({
                id: i,
                phoneNumber,
                minutesAgo,
                amount: amount.toLocaleString(),
                gameIcon
            });
        }
        return cards;
    };

    const [cards] = useState(generateJackpotData());

    return (
        <div className="jackpot-slider">
            <div className="jackpot-slider__container">
                {/* แสดง cards สองรอบเพื่อให้เกิด infinite loop */}
                {[...cards, ...cards].map((card, index) => (
                    <div key={`${card.id}-${index}`} className="jackpot-slider__card">
                        {/* ด้านซ้าย - ไอคอนเกม */}
                        <div className="jackpot-slider__icon-section">
                            <div className="jackpot-slider__icon-circle">
                                <img src={`/games/${card.gameIcon}`} alt={card.gameIcon} />
                            </div>
                        </div>

                        {/* ด้านขวา - รายละเอียด */}
                        <div className="jackpot-slider__details">
                            {/* เบอร์โทร */}
                            <div className="jackpot-slider__phone">
                                {card.phoneNumber}
                            </div>

                            {/* เวลา */}
                            <div className="jackpot-slider__time">
                                {card.minutesAgo} นาทีที่แล้ว
                            </div>

                            {/* จำนวนเงิน */}
                            <div className="jackpot-slider__amount">
                                ฿{card.amount}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default JackpotSlider;